
const PRODUCT_HANDLE='severance';

function setStatus(message){
  document.querySelectorAll('.status').forEach(el=>el.textContent=message);
}

async function addProductToCart(button){
  const original=button.textContent;
  button.disabled=true;
  button.textContent='Adding…';
  setStatus('');

  try{
    const productRes=await fetch(`/products/${PRODUCT_HANDLE}.js`,{credentials:'same-origin'});
    if(!productRes.ok) throw new Error('Could not load product');
    const product=await productRes.json();
    const variant=product.variants.find(v=>v.available)||product.variants[0];
    if(!variant) throw new Error('No available variant');

    const addRes=await fetch('/cart/add.js',{
      method:'POST',
      credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({items:[{id:variant.id,quantity:1}]})
    });

    if(!addRes.ok) throw new Error('Could not add to cart');
    window.location.href='/cart';
  }catch(err){
    console.error(err);
    setStatus('Open this page inside your Shopify store/theme to use the cart button.');
    button.disabled=false;
    button.textContent=original;
  }
}

document.querySelectorAll('[data-buy]').forEach(button=>{
  button.addEventListener('click',()=>addProductToCart(button));
});
